<template>
  <div>
    <ValidationObserver ref="formObserver" tag="form" novalidate>
      <div class="row m-3">
        <em :class="getIcon" />
        <span>{{ getDescription }}</span>
      </div>
      <div class="col-md-12 ml-1 mb-2">
        <div class="row mx-4 mr-1">
          <div v-if="!showNotification" class="col-12 col-md-12 col-lg-8 py-1">
            <label class="input-label">Comentario:</label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              mode="eager"
            >
              <CustomTextArea
                :id="'parenInventoryComment'"
                v-model="comment"
                :maxlength="3000"
                :rows="1"
                :show-char-count="true"
                :single-line="true"
                :error="errors[0]"
                :custom-error-msg.sync="GetMessage('R90019').name"
              />
            </ValidationProvider>
          </div>
          <div v-if="showNotification" class="col-12 col-md-12 col-lg-6 py-1">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              rules="required"
            >
              <custom-drop-down
                :id="'ddlWayId_' + item.sampleInventoryDetailId"
                v-model="sampleNotificationWay"
                fieldname="name"
                fieldkey="id"
                :name="'ddlWayName_' + item.sampleInventoryDetailId"
                :options="notificationWays"
                placeholder="Seleccione"
                label="Medio por cual notificó:"
                :error="errors[0]"
                :custom-error-msg.sync="GetMessage('R90018').name"
              />
            </ValidationProvider>
          </div>
          <div
            class="col-12 col-md-12 py-1 pl-0 mt-3 text-right"
            :class="{
              'col-lg-4 col-xl-4': !showNotification,
              'col-lg-6 col-xl-6': showNotification,
            }"
          >
            <div class="mt-2">
              <ActionButton
                i="fas fa-times-circle"
                variant="outline-danger"
                class="px-3 mt-1 mr-2"
                text="Cancelar"
                @click="cancelStatus"
              />
              <ActionButton
                variant="success"
                class="px-4 mt-1"
                text="Guardar"
                @click="saveStatus"
              />
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { CustomTextArea } from '@/components/common';
import CustomDropDown from '@/components/common/CustomDropDown';
import { ActionButton } from '@/components/common';
import ParentInventoryStatus from '@/utils/constants/student/parentInventoryStatus';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'ParentInventoryActionContent',
  components: {
    CustomDropDown,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    CustomTextArea,
  },
  props: {
    inventoryStatus: {
      type: Number,
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      notificationWays: [],
      status: this.inventoryStatus,
      id: 0,
      comment: null,
      sampleNotificationWay: null,
    };
  },
  watch: {
    inventoryStatus() {
      this.status = this.inventoryStatus;
    },
  },
  methods: {
    async loadSampleNotificationWays() {
      this.$ApiGet(`api/parentInventory/sampleNotificationWays`).then(
        (response) => {
          this.notificationWays = response.data;
        }
      );
    },
    async saveStatus() {
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) return;

      let data = {
        status: this.status,
        comment: this.comment,
        inventoryIdDatailCommetId: this.item.sampleInventoryDetailId,
        sampleNotificationWayid:
          this.sampleNotificationWay != null
            ? this.sampleNotificationWay.id
            : 0,
      };

      this.$emit('saveInventoryStatus', data);
    },
    async cancelStatus() {
      this.$emit('cancelInventoryStatus');
    },
    async LoadValidationMessages() {
      const messageCodes = ['R90019', 'R90018'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    GetMessage(code) {
      const message = this.validationMessages
        ? this.validationMessages.find((element) => element.id == code)
        : '';

      return message;
    },
  },
  computed: {
    showNotification() {
      return this.status === ParentInventoryStatus.Notified;
    },
    getDescription() {
      let description = '';
      switch (this.status) {
        case ParentInventoryStatus.New:
          description = 'Regresar Estatus';
          break;
        case ParentInventoryStatus.Notified:
          description = 'Cambiar a Notificado';
          break;
        case ParentInventoryStatus.Completed:
          description = 'Nuevo';
          break;
        case ParentInventoryStatus.Canceled:
          description = 'Cancelar Estudiante';
          break;
      }

      return description;
    },
    getIcon() {
      if (this.status !== ParentInventoryStatus.Canceled)
        return 'fas fa-flag bg--red text-white p-2 rounded-circle mt-n1 mr-2';

      return 'fas fa-times-circle fa-2x text-red pl-0 rounded-circle mt-n1 mr-2';
    },
  },
  async mounted() {
    this.LoadValidationMessages();
    this.loadSampleNotificationWays();
  },
};
</script>

<style scoped>
.board {
  flex-grow: 3;
}

.bag {
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 10px 30px;
}

textarea#parenInventoryComment {
  min-height: 2.375rem !important;
}

@media screen and (max-width: 850px) {
  .flex {
    flex-wrap: wrap;
  }
  .dd {
    margin-bottom: 5%;
  }
}
</style>
